var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3489 14.3036H8.91875C7.87866 14.3036 6.94258 13.5496 6.73457 12.5355L6.47454 11.3654H9.72482L9.17877 8.76516H5.66848C4.62839 8.76516 3.69231 8.01109 3.48429 6.99701L3.22427 5.7229H10.6609C11.701 5.7229 12.6371 6.47696 12.8451 7.49105L13.1051 8.71315H15.7573L15.3933 6.945C14.9253 4.70882 12.9491 3.09668 10.6609 3.09668H0L0.936079 7.51705C1.27411 9.07718 2.3402 10.3253 3.71831 10.9233L4.18635 13.0555C4.65439 15.2917 6.63056 16.9038 8.89275 16.9038H10.8689L10.3489 14.3036Z",
    fill: "url(#paint0_linear_15792_12272)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4918 9.50603C23.3239 8.54395 23.9999 7.21784 23.9999 5.86573C23.9999 5.31968 23.9219 4.77364 23.7659 4.25359C23.4539 3.05749 22.7258 2.09541 21.6857 1.41935C20.7756 0.821304 19.6575 0.509277 18.3574 0.509277H11.6229L11.0768 3.1095H18.3314C19.1115 3.1095 19.7355 3.26551 20.1776 3.57754L20.2296 3.62954C20.7236 3.94157 21.0617 4.3836 21.2177 4.95565L21.2437 5.03366C21.3217 5.31968 21.3737 5.60571 21.3737 5.89173C21.3737 6.7238 20.6196 7.8679 19.8916 8.41394L18.6435 9.35002L19.8136 10.4161C20.0736 10.6501 20.3076 10.9362 20.4636 11.2222L20.4896 11.2482C20.8276 11.8202 21.0097 12.4963 21.0097 13.1463C21.0097 15.2005 19.3195 16.8907 17.2653 16.8907C17.1353 16.8907 16.7713 16.8907 16.4073 16.8907C15.9912 16.8907 15.6012 16.8907 15.4452 16.8907H8.19058L7.64453 19.4909H15.4452C15.6012 19.4909 15.9912 19.4909 16.4073 19.4909C16.7973 19.4909 17.1613 19.4909 17.2913 19.4909C20.7756 19.4909 23.6359 16.6566 23.6359 13.1463C23.6359 12.0282 23.3239 10.9102 22.7518 9.92207C22.6478 9.76606 22.5698 9.63604 22.4918 9.50603Z",
    fill: "url(#paint1_linear_15792_12272)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15792_12272",
    x1: 13.6665,
    y1: 15.4816,
    x2: 4.14486,
    y2: 2.87016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15792_12272",
    x1: 21.8297,
    y1: 17.5356,
    x2: 8.21939,
    y2: 3.92518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fbLogo.a35b7e4e028896094208b1b9f64080b0.svg";
export { ForwardRef as ReactComponent };